import React, { useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    List,
    ListItem,
    ListItemText,
    ListItemButton,
    ListItemIcon,
} from '@mui/material';
import { companyList } from '../../CompanyProfilePage/modal';

interface CompanySelectDialogProps {
    open: boolean;
    companies: companyList[];
    onClose: () => void;
    onSelect: (companyProfileID: number) => void;
}

const CompanyListDialogBox: React.FC<CompanySelectDialogProps> = ({
    open,
    companies,
    onClose,
    onSelect,
}) => {
    const [selectedCompanyProfileID, setSelectedCompanyProfileID] = React.useState<any>();
   
    const [logoPreview, setLogoPreview] = useState<string | null>(null);
    const [openDialog, setOpenDialog] = useState<boolean>(false);

  

    const handleSelect = (company: companyList) => {
        setSelectedCompanyProfileID(company.companyProfileID)
        onSelect(company.companyProfileID);
        onClose(); // Close the dialog after selection
    }

    const closePreview = () => {
        setOpenDialog(false);
    };

    return (
        <Dialog
            open={open}
            onClose={(event, reason) => {
                // Prevent closing when clicking outside
                if (reason !== 'backdropClick') {
                    return;
                }
            }}
            fullWidth
        >
            <DialogTitle>Select a Company</DialogTitle>
            <DialogContent>
                <List>
                    {companies.map((company) => (
                        <ListItem key={company.companyProfileID} disablePadding>
                            <ListItemButton
                                onClick={() => handleSelect(company)}  // Use ListItemButton for click action
                                selected={selectedCompanyProfileID === company.companyProfileID}  // Use selected with ListItemButton
                                sx={{
                                    '&:hover': {
                                        bgcolor: "#E5F0FF",
                                    },
                                    borderRadius: "8px",
                                    display: "flex",
                                    justifyContent: "space-between"
                                }}
                            >

                                <ListItemText primary={company.companyName} />

                            </ListItemButton>

                        </ListItem>
                    ))}
                </List>
            </DialogContent>
            <Dialog open={openDialog} onClose={closePreview}>
                <DialogTitle>Logo Preview</DialogTitle>
                <DialogContent>
                    {logoPreview && <img src={logoPreview} alt="Logo Preview" style={{ maxWidth: '100%' }} />}
                </DialogContent>
                <DialogActions>
                    <Button onClick={closePreview} color="primary">Close</Button>
                </DialogActions>
            </Dialog>
        </Dialog>
    );
};

export default CompanyListDialogBox;
